import React from "react";
import "../../../CSS/main.css";
import SEOContent from "../../../Images/Schools&Programmes/SEO-Content2.png";
import SEOBrochure from "../../../Assets/Brochures/brochure-seo-paid-course .pdf";
import SEOBanner from "../../../Images/Schools&Programmes/SEO-Banner.jpg";
import { Link } from "react-router-dom";
import MetaTags from "../../MetaInfo/MetaTags";

const PaidSEO = () => {
  const handleBrochure = (SEOBrochure) => {
    window.open(SEOBrochure);
  };
  return (
    <>
      <MetaTags
        title={
          "Online SEO Course in Telugu | Affordable SEO Training with Placement"
        }
        Description={
          "Master SEO in your native language with New Directions Skills. Live & recorded classes, real-time projects, and job support—all at just ₹4,719. Enroll now for career growth in digital marketing!"
        }
        Keywords={
          "SEO course in Telugu  Online SEO training India Learn SEO in Telugu SEO classes with placement support Affordable SEO course online"
        }
        href={"https://ndskills.in/paid-seo"}
      />
      <img src={SEOBanner} alt="SEOBanner Img" className="img-fluid" />

      <div className="container my-md-5">
        <div className="bg-white text-muted md-p-5 rounded-4 d-flex flex-column  seo-title gap-md-3 ">
          <h1 className=" textColor2 text-lg-center">
            Learn SEO in Telugu – Join Our Paid Online SEO Course by New
            Directions Skills
          </h1>
          <p className="">
            Are you looking to build a successful career in digital marketing?
            Do you want to learn a valuable skill that is in high demand across
            the world? Then it’s time to enroll in the Online SEO Course offered
            by New Directions Skills, now available in Telugu, specially
            designed for students, job-seekers, freelancers, and working
            professionals who prefer learning in their native language.
          </p>
          <p>
            Search Engine Optimization (SEO) is the backbone of digital
            marketing. It helps websites rank higher in search engines like
            Google, increases traffic, and drives business success. With our
            industry-focused SEO course, you will learn how to become an expert
            in SEO and confidently apply your knowledge to real-world projects.
          </p>
        </div>

        {/* ************************* Course Highlights: ************************* */}

        <div className="bg-white p-2 p-md-5 rounded-4 shadow-sm Course-Highlights border border-light ">
          <h3 className="textColor2  fw-bold mb-4 text-center">
            🎯 Course Highlights
          </h3>

          <div className="row g-3 g-md-4">
            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className="fs-3 me-3">📚</span>
                <div>
                  <h6 className="fw-semibold mb-1">SEO Course in Telugu</h6>
                  <p className="mb-0 text-muted">
                    Learn each concept clearly in your own language.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🧑‍🏫</span>
                <div>
                  <h6 className="fw-semibold mb-1">Live & Recorded Classes</h6>
                  <p className="mb-0 text-muted">
                    Watch videos anytime and join interactive live sessions.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🔍</span>
                <div>
                  <h6 className="fw-semibold mb-1">Basic to Advanced SEO</h6>
                  <p className="mb-0 text-muted">
                    Covers keyword research, On/Off-page SEO, technical SEO &
                    more.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">💼</span>
                <div>
                  <h6 className="fw-semibold mb-1">Placement Support</h6>
                  <p className="mb-0 text-muted">
                    We’ll guide you toward job opportunities post-training.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">🧑‍💻</span>
                <div>
                  <h6 className="fw-semibold mb-1">Real-Time Projects</h6>
                  <p className="mb-0 text-muted">
                    Work with tools like GA, Search Console, SEMrush, and more.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex align-items-center justify-content-center bg-light rounded-4 p-3 shadow-sm h-100">
                <span className=" fs-3 me-3">📄</span>
                <div>
                  <h6 className="fw-semibold mb-1">Certification</h6>
                  <p className="mb-0 text-muted">
                    Get a recognized course certificate to enhance your resume.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ************************* Who Can Join This Course? ************************* */}

        <div className=" p-md-5 rounded-4  mt-3 CourseDetails mt-md-5">
          <div className="row g-4 align-items-start">
            {/* *************** Who Can Join Section *************** */}
            <div className="col-md-6">
              <div className="p-3 p-md-4 h-100 rounded-4 d-flex flex-column shadow-sm border bg-light">
                <h4 className="text-primary fw-bold mb-3">
                  Who Can Join This Course?
                </h4>
                <ul className="list-unstyled mb-3 text-dark">
                  <li className="mb-2">✅ Students & Graduates</li>
                  <li className="mb-2">
                    ✅ Job Seekers aiming for Digital Marketing
                  </li>
                  <li className="mb-2">✅ Freelancers & Home Makers</li>
                  <li className="mb-2">✅ Small Business Owners</li>
                  <li className="mb-2">
                    ✅ Working Professionals upgrading skills
                  </li>
                </ul>
                <p className="text-muted small mb-0">
                  No prior SEO or coding experience required. Just basic
                  computer and internet knowledge is enough to get started.
                </p>
              </div>
            </div>

            {/* *************** Course Fee Section *************** */}
            <div className="col-md-6">
              <div
                className="p-3 p-md-4 h-100 rounded-4 d-flex flex-column shadow-sm border"
                style={{ backgroundColor: "#fff8f4" }}
              >
                <h4 className="text-danger fw-bold mb-3">Course Fee Details</h4>
                <ul className="list-unstyled text-dark mb-3">
                  <li className="mb-2">✅ SEO Course Fee – ₹3,999/-</li>
                  <li className="mb-2">✅ GST 18% – ₹720/-</li>
                  <li className="mb-2 fw-semibold">✅ Total – ₹4,719/- only</li>
                </ul>
                <p className="text-muted small mb-4 mb-md-5 mb-lg-3">
                  One-time fee includes lifetime access to recorded content,
                  placement support, and personalized career guidance from our
                  experts.
                </p>
                <div className=" d-flex  gap-2 gap-md-4 seo-button justify-content-around">
                  <button className="btn1  px-lg-4 px-3 py-2 rounded-3 shadow-sm">
                    <Link
                      to="https://forms.gle/n6jUHxwq9AtEt4ac8"
                      target="_blank"
                      className="text-decoration-none text-white"
                    >
                      Apply Now
                    </Link>
                  </button>
                  <button
                    className="btn1 px-lg-4 py-2 px-3 rounded-3 shadow-sm"
                    onClick={() => handleBrochure(SEOBrochure)}
                  >
                    Download Brochure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*   ************************************* What You Will Learn *********************************/}

        <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border border-light mt-3 mt-md-5   d-flex justify-content-center flex-column mx-auto">
          <div className=" mx-auto">
            <h3 className="textColor2 fw-bold text-center mb-3 Learn mb-md-5">
              What You Will Learn ?
            </h3>
            <img
              src={SEOContent}
              alt="SEOContent Img"
              className=" img-fluid"
              style={{ width: "700px" }}
            />
          </div>
        </div>

        {/* ********************************  Why Choose New Directions Skills ******************************* */}

        <div className="bg-white p-2 p-md-5 rounded-4 shadow-sm border why-ndskill border-1 border-light mt-3 mt-md-5 ">
          <h3 className="text-center text-primary fw-bold  mb-3 mb-md-5">
            Why Choose <span className="text-dark">New Directions Skills?</span>
          </h3>

          <div className="row row-cols-1 row-cols-md-2 g-3 g-md-4">
            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4  border-bottom shadow-sm p-1  p-2 p-md-3 h-100 border-start border-4 border-success">
                <div className="fs-2 me-3 text-success">🗣️</div>
                <div>
                  <h6 className="fw-semibold mb-1">
                    Training in Telugu Language
                  </h6>
                  <p className="text-muted mb-0">
                    Understand every topic in your native language for better
                    clarity.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light border-bottom rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-info">
                <div className="fs-2 me-3 text-info">👨‍🏫</div>
                <div>
                  <h6 className="fw-semibold mb-1">Expert Trainers</h6>
                  <p className="text-muted mb-0">
                    Learn directly from professionals with hands-on industry
                    experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light border-bottom rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-warning">
                <div className="fs-2 me-3 text-warning">💰</div>
                <div>
                  <h6 className="fw-semibold mb-1">Affordable Fees</h6>
                  <p className="text-muted mb-0">
                    Get premium training without burning a hole in your pocket.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4 border-bottom shadow-sm  p-2 p-md-3 h-100 border-start border-4 border-primary">
                <div className="fs-2 me-3 text-primary">🧾</div>
                <div>
                  <h6 className="fw-semibold mb-1">Placement Assistance</h6>
                  <p className="text-muted mb-0">
                    Resume building and interview prep to help you land your
                    dream job.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex align-items-start bg-light rounded-4 shadow-sm  p-2 p-md-3 h-100 border-start  border-bottom border-4 border-danger">
                <div className="fs-2 me-3 text-danger">🌐</div>
                <div>
                  <h6 className="fw-semibold mb-1">24/7 Course Access</h6>
                  <p className="text-muted mb-0">
                    Learn anytime, anywhere—no limits on when you study.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 mt-md-5 text-lg-center">
            <p className="text-muted ">
              Start your digital career today with a skill that ensures future
              growth. Our <strong>SEO course in Telugu</strong> is ideal for
              beginners—even with no technical background—to confidently step
              into the world of online marketing.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaidSEO;
